import { DatePicker, Button } from "antd";
import moment from "moment";
const { RangePicker } = DatePicker;

/**
 * 生成通用的 RangePicker filterDropdown
 * @param {Object} params
 * @param {string} startKey - tableHead 开始时间字段
 * @param {string} endKey - tableHead 结束时间字段
 * @param {Function} setDates - 设置本地 state（页面里传过来）
 * @param {Array} dates - 当前 state 的值
 * @param {Function} setTableHead - 更新筛选条件
 * @param {Function} getTableListFn - 刷新表格数据
 * @param {Object} pagination - 分页对象
 */
export const createRangeFilter = ({
  startKey,
  endKey,
  setDates,
  dates,
  setTableHead,
  getTableListFn,
  pagination,
}) => {
  const handleOk = (selectedDates, confirm) => {
    if (!selectedDates || selectedDates.length !== 2) return;
    const startTime = selectedDates[0].valueOf();
    const endTime = selectedDates[1].valueOf();
    setTableHead((prev) => {
      const updated = {
        ...prev,
        [startKey]: startTime,
        [endKey]: endTime,
      };
      getTableListFn(1, pagination.pageSize, updated);
      return updated;
    });
    confirm?.();
  };

  const handleReset = (clearFilters) => {
    clearFilters?.();
    setDates([]);
    setTableHead((prev) => {
      const updated = {
        ...prev,
        [startKey]: "",
        [endKey]: "",
      };
      getTableListFn(1, pagination.pageSize, updated);
      return updated;
    });
  };

  return ({ confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <RangePicker
        allowClear={false}
        format="MM/DD/YYYY"
        value={dates}
        onChange={(selectedDates) => {
          setDates(selectedDates);
          handleOk(selectedDates, confirm);
        }}
      />
      <Button
        size="small"
        style={{ width: 60, marginLeft: 10 }}
        onClick={() => handleReset(clearFilters)}
      >
        Reset
      </Button>
    </div>
  );
};